import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import {
  eagerLoadedBillBillerService,
  Service
} from '../interfaces/biller-interfaces';

@Injectable({
  providedIn: 'root',
})
export class selectedServiceNotifierService {
  private selectedService: Subject<Service[]> = new BehaviorSubject<Service[]>(
    null
  );
  private billProviderAndServices: EventEmitter<eagerLoadedBillBillerService[]> =
    new EventEmitter<eagerLoadedBillBillerService[]>();
  pushbillProviderAndServices(
    billProviderAndServices: eagerLoadedBillBillerService[]
  ) {
    this.billProviderAndServices.emit(billProviderAndServices);
  }
  getbillProviderAndServices() {
    return this.billProviderAndServices;
  }
  pushSelectedService(services: Service[]) {
    this.selectedService.next(services);
  }
  getSelectedServiceNotification() {
    return this.selectedService;
  }
}
